// extracted by mini-css-extract-plugin
export default {"root":"Page_root__3SIRI","content":"Page_content__2COkr","scrollingDisabled":"Page_scrollingDisabled__3F51e"};